/* eslint-disable react/jsx-no-undef */
import React from "react";
import Container from "@mui/material/Container";
import InputLabel from "@mui/material/InputLabel";
import registerStep3 from '../../assets/images/register/register-step-3-4.svg';
import member from "../../assets/images/register/member.svg";
import { Autocomplete, Checkbox, TextField } from "@mui/material";

import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import TopBanner from '../../components/layout/TopBanner';
import { setRegisterMain } from '../../features/register/RegisterMainSlice';
import { useDispatch, useSelector } from 'react-redux';
import TopLogo from '../../components/layout/TopLogo';
import globalStyle from "../../assets/styles/constants";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import { SearchDdlAddress } from "../../services/Dropdown";
import { useLiff } from 'react-liff';
import { CreateMember } from "../../services/Register";
import dayjs from "dayjs";
import CustomPopup from "../../components/popup/CustomPopup";
import ErrorPopup from "../../components/popup/ErrorPopup";

export default function RegisterMember2() {

  // lineId
  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;

  const store = useSelector((state) => state.registerMain)
  const dispatch = useDispatch()
  const navigate = useNavigate();

  const txt = {
    require: "กรุณากรอก",
    province: "จังหวัด",
    amphoe: "เขต/อำเภอ",
    tambol: "แขวง/ตำบล",
    zipCode: "รหัสไปรษณีย์",
  };

  const [addressList, setAddressList] = React.useState([]);
  const [delayId, setDelayId] = React.useState(null);
  const [subDistrict, setSubDistrict] = React.useState(null);
  const [amphoe, setAmphoe] = React.useState(null);
  const [province, setProvince] = React.useState(null);
  const [zipCode, setZipCode] = React.useState(null);

  const [openSubDistrict, setOpenSubDistrict] = React.useState(false);
  const [openAmphoe, setOpenAmphoe] = React.useState(false);
  const [openProvince, setOpenProvince] = React.useState(false);
  const [openZipCode, setOpenZipCode] = React.useState(false);

  const [deSubDistrict, setDeSubDistrict] = React.useState(null);
  const [deAmphoe, setDeAmphoe] = React.useState(null);
  const [deProvince, setDeProvince] = React.useState(null);
  const [deZipCode, setDeZipCode] = React.useState(null);

  const [openDeSubDistrict, setOpenDeSubDistrict] = React.useState(false);
  const [openDeAmphoe, setOpenDeAmphoe] = React.useState(false);
  const [openDeProvince, setOpenDeProvince] = React.useState(false);
  const [openDeZipCode, setOpenDeZipCode] = React.useState(false);

  const [openCancelPopup, setOpenCancelPopup] = React.useState(false);
  const [popupTitle, setPopupTitle] = React.useState('เกิดข้อผิดพลาด ')
  const [popupDesc, setPopupDesc] = React.useState('')

  const [openErrorPopup, setOpenErrorPopup] = React.useState(false);
  const [isSubmit, setIsSubmit] = React.useState(false)

  const { register, formState: { errors }, handleSubmit, getValues, setValue, control, watch } = useForm({
    defaultValues: {
      address: store['addressDetail'],
      subDistrictId: store['subDistrictId'],
      amphoeId: store['amphoeId'],
      provinceId: store['provinceId'],
      zipCode: store['zipCode'],
      isDeliveryAddress: store['isDeliveryAddress'],
      deAddress: store['deAddressDetail'],
      deSubDistrictId: store['deSubDistrictId'],
      deAmphoeId: store['deAmphoeId'],
      deProvinceId: store['deProvinceId'],
      deZipCode: store['deZipCode'],
      recommendCode: store['recommendCode']
    }
  });

  function fnSetData(name, value) {
    const tmpObj = {};
    tmpObj[name] = value;
    dispatch(setRegisterMain(tmpObj));
  }

  React.useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name && type) {
        fnSetData(name, value[name]);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const onSubmit = (data) => {
    postCreateMember()
  };

  async function getSearchDdlAddress(search) {
    try {
      const { data } = await SearchDdlAddress({ params: { search } });
      if (+data["resultCode"] === 20000) {
        const body = data.body || [];
        setAddressList(body);
      } else {
        setAddressList([]);
      }
    } catch (error) {
      console.log("getSearchDdlAddress error", error);
    }
  }

  function fnOnChangeAddress(e, value) {
    fnSetOpenAddress(txt.tambol, false);
    fnSetOpenAddress(txt.amphoe, false);
    fnSetOpenAddress(txt.province, false);
    fnSetOpenAddress(txt.zipCode, false);
    setSubDistrict(value);
    setValue("subDistrictId", value.subDistrictId);
    fnSetData("subDistrictId", value.subDistrictId);
    setAmphoe(value);
    setValue("amphoeId", value.amphoeId);
    fnSetData("amphoeId", value.amphoeId);
    setProvince(value);
    setValue("provinceId", value.provinceId);
    fnSetData("provinceId", value.provinceId);
    setZipCode(value);
    setValue("zipCode", value.zipcode);
    fnSetData("zipCode", value.zipcode);
  }

  async function onInputChangeAddress(e, type) {
    fnSetOpenAddress(type, false);
    const value = e.target.value;
    clearTimeout(delayId);
    const timeoutId = setTimeout(async () => {
      if (value) {
        await getSearchDdlAddress(value);
        fnSetOpenAddress(type, true);
      } else {
        setAddressList([]);
      }
    }, 500);
    setDelayId(timeoutId);
  }

  function fnSetOpenAddress(type, open) {
    if (type === txt.tambol) {
      setOpenSubDistrict(open);
    } else if (type === txt.amphoe) {
      setOpenAmphoe(open);
    } else if (type === txt.province) {
      setOpenProvince(open);
    } else if (type === txt.zipCode) {
      setOpenZipCode(open);
    }
  }

  function fnOnChangeDeAddress(e, value) {
    fnSetOpenDeAddress(txt.tambol, false);
    fnSetOpenDeAddress(txt.amphoe, false);
    fnSetOpenDeAddress(txt.province, false);
    fnSetOpenDeAddress(txt.zipCode, false);
    setDeSubDistrict(value);
    setValue("deSubDistrictId", value.subDistrictId);
    fnSetData("deSubDistrictId", value.subDistrictId);
    setDeAmphoe(value);
    setValue("deAmphoeId", value.amphoeId);
    fnSetData("deAmphoeId", value.amphoeId);
    setDeProvince(value);
    setValue("deProvinceId", value.provinceId);
    fnSetData("deProvinceId", value.provinceId);
    setDeZipCode(value);
    setValue("deZipCode", value.zipcode);
    fnSetData("deZipCode", value.zipcode);
  }

  async function onInputChangeDeAddress(e, type) {
    fnSetOpenDeAddress(type, false);
    const value = e.target.value;
    clearTimeout(delayId);
    const timeoutId = setTimeout(async () => {
      if (value) {
        await getSearchDdlAddress(value);
        fnSetOpenDeAddress(type, true);
      } else {
        setAddressList([]);
      }
    }, 500);
    setDelayId(timeoutId);
  }

  function fnSetOpenDeAddress(type, open) {
    if (type === txt.tambol) {
      setOpenDeSubDistrict(open);
    } else if (type === txt.amphoe) {
      setOpenDeAmphoe(open);
    } else if (type === txt.province) {
      setOpenDeProvince(open);
    } else if (type === txt.zipCode) {
      setOpenDeZipCode(open);
    }
  }

  function fnRenderOption(props, option, { inputValue }) {
    const address1 = `${option.subDistrict}, ${option.amphoe}, ${option.zipcode}`;
    const address2 = `จังหวัด ${option.province}`;

    const matches1 = match(address1, inputValue, { insideWords: true });
    const parts1 = parse(address1, matches1);

    const matches2 = match(address2, inputValue, { insideWords: true });
    const parts2 = parse(address2, matches2);

    return (
      <li {...props} className="text-left pl-1 border-address-list">
        {/*display address*/}
        <div>
          {parts1.map((part, index) => (
            <span
              key={index}
              style={{
                fontWeight: part.highlight ? 700 : 400,
                color: part.highlight ? "#0A4197" : "#8F8F8F",
              }}
            >
              {part.text}
            </span>
          ))}
        </div>
        {/*display province*/}
        <div>
          {parts2.map((part, index) => (
            <span
              key={index}
              style={{
                fontWeight: part.highlight ? 700 : 400,
                color: part.highlight ? "#0A4197" : "#8F8F8F",
              }}
            >
              {part.text}
            </span>
          ))}
        </div>
      </li>
    );
  }

  function fnSetIsDeliveryAddress(checked) {
    if (checked) {
      setValue("deAddress", getValues('address'));
      fnSetData("deAddress", getValues('address'));
      setValue("deSubDistrictId", getValues('subDistrictId'));
      fnSetData("deSubDistrictId", getValues('subDistrictId'));
      setDeAmphoe(amphoe);
      setValue("deAmphoeId", getValues('amphoeId'));
      fnSetData("deAmphoeId", getValues('amphoeId'));
      setDeProvince(province);
      setValue("deProvinceId", getValues('provinceId'));
      fnSetData("deProvinceId", getValues('provinceId'));
      setDeZipCode(zipCode);
      setValue("deZipCode", getValues('zipCode'));
      fnSetData("deZipCode", getValues('zipCode'));
    } else {
      setValue("deAddress", '');
      fnSetData("deAddress", '');
      setDeSubDistrict(null);
      setValue("deSubDistrictId", '');
      fnSetData("deSubDistrictId", '');
      setDeAmphoe(null);
      setValue("deAmphoeId", '');
      fnSetData("deAmphoeId", '');
      setDeProvince(null);
      setValue("deProvinceId", '');
      fnSetData("deProvinceId", '');
      setDeZipCode(null);
      setValue("deZipCode", '');
      fnSetData("deZipCode", '');
    }

  }

  async function postCreateMember() {
    try {
      setIsSubmit(true)
      let payload = {
        lineId: lineId,
        firstName: store['firstName'],
        lastName: store['lastName'],
        email: store['email'],
        mobileNumber: store['mobileNumber'],
        birthdate: dayjs(store['birthDate']).add(7, 'hours'),
        addressDetails: store['address'],
        amphoe: store['amphoeId'],
        district: store['subDistrictId'],
        province: store['provinceId'],
        zipCode: store['zipCode'],
        isDeliveryAddress: store['isDeliveryAddress'],
        deAddressDetails: store['isDeliveryAddress'] ? store['address'] : store['deAddress'],
        deAmphoe: store['isDeliveryAddress'] ? store['amphoeId'] : store['deAmphoeId'],
        deDistrict: store['isDeliveryAddress'] ? store['subDistrictId'] : store['deSubDistrictId'],
        deProvince: store['isDeliveryAddress'] ? store['provinceId'] : store['deProvinceId'],
        deZipCode: store['isDeliveryAddress'] ? store['zipCode'] : store['deZipCode'],
        recommendCode: store['recommendCode'],
        fullName: store['firstName'] + ' ' + store['lastName'],
        fullAddress: amphoe ? `${store['address']} ${amphoe.amphoe} ${subDistrict.subDistrict} ${province.province} ${getValues('zipCode')}` : getValues('addressDetails'),
        fullDeAddress: getValues('isDeliveryAddress') ? (amphoe ? `${store['address']} ${amphoe.amphoe} ${subDistrict.subDistrict} ${province.province} ${getValues('zipCode')}` : getValues('address')) : (deAmphoe ? `${getValues('deAddressDetails')} ${deAmphoe ? deAmphoe.amphoe : ''} ${deSubDistrict ? deSubDistrict.subDistrict : ''} ${deProvince ? deProvince.province : ''} ${getValues('deZipCode')}` : getValues('deAddressDetails')),
        isTerm: true
      }

      Object.keys(payload).forEach(key => {
        if (payload[key] === null) {
          delete payload[key];
        }
      });

      const { data } = await CreateMember({ data: payload });
      if (+data["resultCode"] === 20000) {
        navigate("/register-member-3", { state: data });
      } else {
        setIsSubmit(false)
        setOpenErrorPopup(true)
      }
    } catch (error) {
      console.log("postCreateMember error", error);
    }
  }


  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <ErrorPopup
        open={openErrorPopup}
        actionFunction={() => {
          setOpenErrorPopup(false)
        }}
      />
        <TopLogo />
        <TopBanner type="register" />
        <Container maxWidth="xl" className="mt-[-20px]">
          <div className="bg-white px-3">
            <img src={registerStep3} alt="logo" style={{ width: "100%" }} />
            <div style={{ fontSize: 30, textAlign: "center" }}>
              ลงทะเบียนสำหรับ
              <span style={{ fontWeight: "bold" }}> ผู้ใช้งานทั่วไป</span>
            </div>
            <div style={{ textAlign: "center" }}>
              <img
                src={member}
                alt="logo"
                style={{ width: "20%", display: "initial" }}
              />
            </div>
            <div style={{ padding: "0 10px" }}>
              <div className="flex gap-[10px] justify-start">
                <div className="primary-color title-size">ที่อยู่</div>
                <div style={{ marginTop: "6px" }}>
                  <p className="sub-title-size">Address</p>
                  <div className="blue-line" ></div>
                </div>
              </div>
              <div className="">
                <InputLabel className="text-header1 text-left" htmlFor="txtAddress">ที่อยู่</InputLabel>
                <TextField
                  id="txtAddress"
                  fullWidth
                  placeholder="ที่อยู่ของคุณ"
                  {...register("address")}
                />
              </div>

              <div className="grid grid-cols-2 gap-2 mt-2">
                <InputLabel required={true} className="text-header1 text-left" htmlFor="ddlSubDistrict">แขวง / ตำบล</InputLabel>
                <InputLabel required={true} className="text-header1 text-left" htmlFor="ddlDistrict">เขต / อำเภอ</InputLabel>
              </div>
              <div className="grid grid-cols-2 gap-5">
                <Controller
                  name="subDistrictId"
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      freeSolo
                      disableClearable
                      onChange={fnOnChangeAddress}
                      options={addressList}
                      open={openSubDistrict}
                      onClose={() => fnSetOpenAddress(txt.tambol, false)}
                      getOptionLabel={(option) => option.subDistrict}
                      value={subDistrict}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          placeholder="พิมพ์แขวง/ตำบล"
                          onInput={(e) => onInputChangeAddress(e, txt.tambol)}
                        />
                      )}
                      renderOption={fnRenderOption}
                    />
                  )}
                />

                <Controller
                  name="amphoeId"
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      freeSolo
                      disableClearable
                      onChange={fnOnChangeAddress}
                      options={addressList}
                      open={openAmphoe}
                      onClose={() => fnSetOpenAddress(txt.amphoe, false)}
                      getOptionLabel={(option) => option.amphoe}
                      value={amphoe}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          placeholder="พิมพ์เขต/อำเภอ"
                          onInput={(e) => onInputChangeAddress(e, txt.amphoe)}
                        />
                      )}
                      renderOption={fnRenderOption}
                    />
                  )}
                />

              </div>

              <div className="mt-2">
                <InputLabel className="text-header1 text-left" htmlFor="ddlProvince">จังหวัด</InputLabel>
                <Controller
                  name="provinceId"
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      freeSolo
                      disableClearable
                      onChange={fnOnChangeAddress}
                      options={addressList}
                      open={openProvince}
                      onClose={() => fnSetOpenAddress(txt.province, false)}
                      getOptionLabel={(option) => option.province}
                      value={province}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          placeholder="พิมพ์จังหวัด"
                          onInput={(e) => onInputChangeAddress(e, txt.province)}
                        />
                      )}
                      renderOption={fnRenderOption}
                    />
                  )}
                />
              </div>

              <div className="mt-2">
                <InputLabel className="text-header1 text-left" htmlFor="txtZipCode">รหัสไปรษณีย์</InputLabel>
                <Controller
                  name="zipCode"
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      freeSolo
                      disableClearable
                      onChange={fnOnChangeAddress}
                      options={addressList}
                      open={openZipCode}
                      onClose={() => fnSetOpenAddress(txt.zipCode, false)}
                      getOptionLabel={(option) => option.zipcode}
                      value={zipCode}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          placeholder="พิมพ์รหัสไปรษณีย์"
                          onInput={(e) => onInputChangeAddress(e, txt.zipCode)}
                        />
                      )}
                      renderOption={fnRenderOption}
                    />
                  )}
                />
              </div>


              <div className="flex gap-[5px] justify-start mt-2">
                <Checkbox
                  checked={store['isDeliveryAddress']}
                  onChange={(event) => {
                    fnSetData("isDeliveryAddress", !store['isDeliveryAddress']);
                    fnSetIsDeliveryAddress(event.target.checked)
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                  sx={globalStyle.checkboxStyle}
                />
                <p style={{ fontSize: "20px" }} className="text-left mt-[4px]">ใช้ที่อยู่นี้เป็นที่อยู่จัดส่ง</p>
              </div>

              {!store['isDeliveryAddress'] && (
                <div className="mb-[10px]">
                  <div className="">
                    <InputLabel className="text-header1 text-left" htmlFor="txtAddress">ที่อยู่</InputLabel>
                    <TextField
                      id="txtAddress"
                      fullWidth
                      placeholder="ที่อยู่ของคุณ"
                      {...register("deAddress")}
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-2 mt-2">
                    <InputLabel required={true} className="text-header1 text-left" htmlFor="ddlSubDistrict">แขวง / ตำบล</InputLabel>
                    <InputLabel required={true} className="text-header1 text-left" htmlFor="ddlDistrict">เขต / อำเภอ</InputLabel>
                  </div>
                  <div className="grid grid-cols-2 gap-5">
                    <Controller
                      name="deSubDistrictId"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          freeSolo
                          disableClearable
                          onChange={fnOnChangeDeAddress}
                          options={addressList}
                          open={openDeSubDistrict}
                          onClose={() => fnSetOpenDeAddress(txt.tambol, false)}
                          getOptionLabel={(option) => option.subDistrict}
                          value={deSubDistrict}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              placeholder="พิมพ์แขวง/ตำบล"
                              onInput={(e) => onInputChangeDeAddress(e, txt.tambol)}
                            />
                          )}
                          renderOption={fnRenderOption}
                        />
                      )}
                    />

                    <Controller
                      name="deAmphoeId"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          freeSolo
                          disableClearable
                          onChange={fnOnChangeDeAddress}
                          options={addressList}
                          open={openDeAmphoe}
                          onClose={() => fnSetOpenDeAddress(txt.amphoe, false)}
                          getOptionLabel={(option) => option.amphoe}
                          value={deAmphoe}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              placeholder="พิมพ์เขต/อำเภอ"
                              onInput={(e) => onInputChangeDeAddress(e, txt.amphoe)}
                            />
                          )}
                          renderOption={fnRenderOption}
                        />
                      )}
                    />

                  </div>

                  <div className="mt-2">
                    <InputLabel className="text-header1 text-left" htmlFor="ddlProvince">จังหวัด</InputLabel>
                    <Controller
                      name="deProvinceId"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          freeSolo
                          disableClearable
                          onChange={fnOnChangeDeAddress}
                          options={addressList}
                          open={openDeProvince}
                          onClose={() => fnSetOpenDeAddress(txt.province, false)}
                          getOptionLabel={(option) => option.province}
                          value={deProvince}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              placeholder="พิมพ์จังหวัด"
                              onInput={(e) => onInputChangeDeAddress(e, txt.province)}
                            />
                          )}
                          renderOption={fnRenderOption}
                        />
                      )}
                    />
                  </div>

                  <div className="mt-2">
                    <InputLabel className="text-header1 text-left" htmlFor="txtZipCode">รหัสไปรษณีย์</InputLabel>
                    <Controller
                      name="deZipCode"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          freeSolo
                          disableClearable
                          onChange={fnOnChangeDeAddress}
                          options={addressList}
                          open={openDeZipCode}
                          onClose={() => fnSetOpenDeAddress(txt.zipCode, false)}
                          getOptionLabel={(option) => option.zipcode}
                          value={deZipCode}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              placeholder="พิมพ์รหัสไปรษณีย์"
                              onInput={(e) => onInputChangeDeAddress(e, txt.zipCode)}
                            />
                          )}
                          renderOption={fnRenderOption}
                        />
                      )}
                    />
                  </div>
                </div>
              )}


              {/* <p style={{ fontSize: "20px" }} className="text-left mt-[4px]">กรอกรหัสผู้แนะนำ เพื่อรับสิทธิพิเศษเพิ่ม</p>
              <div className="">
                <InputLabel className="text-header1 text-left" htmlFor="txtrecommendCode">รหัสผู้แนะนำ</InputLabel>
                <TextField
                  id="txtrecommendCode"
                  fullWidth
                  placeholder="HE0001"
                  {...register("recommendCode")}
                />
              </div> */}

              <br></br>
              <br></br>
            </div>
          </div>
        </Container>
        <div className="bg-white mt-[20px] h-[100px] pt-[25px]">
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <SecondaryButton variant="outlined" className="w-[40%]" onClick={() => navigate(-1)}>
              ย้อนกลับ
            </SecondaryButton>
            <PrimaryButton variant="contained" className="w-[40%]" type="submit" disabled={isSubmit}>
              ต่อไป
            </PrimaryButton>
          </Stack>
        </div>
      </form>
      <CustomPopup
        title={popupTitle}
        desc={popupDesc}
        cancelText="ปิด"
        cancelFunction={() => {
          setOpenCancelPopup(false);
        }}
        open={openCancelPopup}
        onClose={() => {
          // setOpenCancelPopup(false);
        }}
      />
    </>
  );
}
